import useSWR, {SWRConfiguration} from "swr";
import {apiEndpoints} from "@/utils/api-endpoints";
import {fetcher} from "@/lib/swr-config";
import {IsacoResponse} from "@/types/isaco";


export function useIsacoList(
    searchText: string,
    page: string,
    options?: SWRConfiguration<IsacoResponse>
) {
    const url = `${apiEndpoints.Isaco.GetAll.url}?searchText=${searchText}&page=${page}`;
    return useSWR<IsacoResponse>(url, fetcher, {
        ...options,
    });
}

